// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementReportTileResult = objectOf({
  id: string,
  tile_data_query_id: string,
  x_axis: string,
  group_by: string,
  chart_type: string,
  title: string,
  ignore_columns: arrayOf(string),
  use_rows_with_values: arrayOf(string),
});
